import React from "react";
import { PlaybookContextProvider } from "../../context/playbookContext";
import PlaybookResult from "../../components/Playbook/PlaybookResult";

const Playbook = () => {
  return (
    <PlaybookContextProvider>
      <PlaybookResult />
    </PlaybookContextProvider>
  );
};

export default Playbook;
